import { h } from 'preact'
import { route } from 'preact-router'
import moment from 'moment'
import FirebaseComponent from './FirebaseComponent'
import * as firebase from 'firebase'
import { filter, head, pipe } from 'ramda'

import './SignInWithFacebook.css'

class SignInWithFacebook extends FirebaseComponent {
  constructor() {
    super()
    this.signIn = this.signIn.bind(this)
    this.loadingSpinner = this.loadingSpinner.bind(this)
  }

  signIn(event) {
    event.preventDefault()
		this.setState({ loading: true })
    const provider = new firebase.auth.FacebookAuthProvider()
    firebase.auth().signInWithPopup(provider)
      .then(result => {
        const currentUser = firebase.auth().currentUser

        const getFacebookProvider = pipe(
          filter(provider => provider.providerId === 'facebook.com'),
          head
        )
        const facebookUser = getFacebookProvider(currentUser.providerData)
        const names = facebookUser.displayName.split(' ')

        firebase.database().ref(`accounts/${currentUser.uid}/registeredAt`).set(moment(new Date()).format())
        firebase.database().ref(`profiles/${currentUser.uid}/firstName`).set(names[0])
        firebase.database().ref(`profiles/${currentUser.uid}/lastName`).set(names[1])
        firebase.database().ref(`profiles/${currentUser.uid}/profileImage`).set(facebookUser.photoURL)
        firebase.database().ref(`profiles/${currentUser.uid}/email`).set(facebookUser.email)

        this.setState({ loading: false })
        route("/")
    }).catch(error => {
      this.setState({ message: error.message, loading: false })
		})

  }

  loadingSpinner() {
    if (this.state.loading) return <i className="fa fa-spinner fa-spin" style={{ 'font-size': '24px' }}></i>
  }

  render() {
    return (
      <div className="facebook-login">
        <button className="btn btn-sm btn-facebook btn-block" onClick={this.signIn}>
          {this.loadingSpinner()}
          <span> </span>
          <i class="fa fa-facebook-official" aria-hidden="true"></i>
          <span> </span>
          {this.props.buttonText.toUpperCase()}
        </button>
        {this.state.message}
      </div>
    )
  }
}

export default SignInWithFacebook



// WEBPACK FOOTER //
// ./src/SignInWithFacebook.js